import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const FoodCardToLogin = styled.div`
  display: none;
  width: 320px !important;
  height: 350px !important;
  min-width: 320px !important;
  min-height: 350px !important;
  box-shadow: 4px 4px 4px 0px #00000040;
  ${breakpoints.phone} {
    max-width: 100%;
    max-height: 100%;
  }
  &.isOpen {
    display: flex;
    flex-direction: column;
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    padding: 20px;
    top: 60px;
    left: 50%;
    z-index: 10;
    background: ${Color.greyF5F5F5};
    opacity: 0.95;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background: ${ColorDark.darkGrey} !important;
      }
    }
    ${breakpoints.phone} {
      top: 0;
      left: 0;
    }
  }
  .close-button {
    all: unset;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    margin: 18px;
    svg {
      width: 23px;
      height: 23px;
      &:hover {
        fill: ${Color.grey} !important;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          fill: ${ColorDark.textLight} !important;
        }
      }
    }
  }
  .food-card-login-title p {
    ${Font.sansBold};
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    margin: 16px 0;
    color: ${Color.black000};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight} !important;
      }
    }
  }
  form {
    width: 100%;
  }
  .food-card-login-img {
    width: 280;
    height: 122;
    img {
      width: 100%;
      max-width: 100%;
    }
  }
  .button-login {
    width: 220px;
    height: 40px;
    border-radius: 30px;
    gap: 10px;
    margin-top: 20px;
    &:hover {
      background-color: ${Color.grey}; 
      span {
        color: ${Color.white};
      }
      svg {
        fill: ${Color.white} !important;
      }
    }
    span {
      ${Font.sansRegular};
      font-size: 16px;
      line-height: 14px;
      color: ${Color.black000};
      text-transform: none !important;
      margin-bottom: 0;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    & > div {
      svg {
        width: 14px;
        height: 14px;
        fill: ${Color.black000};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            fill: ${ColorDark.textLight} !important;
          }
        }
      }
    }
  }
`;

export const Login = styled.div`
  align-items: center;
  background-color: inherit;
  border: 1px solid ${Color.grey};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  margin: 0 0 0 15px;
  white-space: nowrap;
  cursor: pointer;
  width: 152px;
  height: 44px;
  margin: 0 0 0 15px;
`;
